import type { RouteLocationAsRelativeGeneric } from 'vue-router'
import { CashPages } from '../../router/routes/cash'
import { RegionPages } from '../../router/routes/region'
import { InventoryPages } from '../../router/routes/inventory'
import { MetadataPages } from '../../router/routes/metadata'
import { OrganizationPages } from '../../router/routes/organization'
import { UserPages } from '../../router/routes/user'
import { WarehousePages } from '../../router/routes/warehouse'
import { RolePages } from '../../router/routes/role'
import { SupplierContractPages } from '../../router/routes/supplier-contract'
import { StoreInPages } from '../../router/routes/store-in'
import { StoreWriteOffPages } from '../../router/routes/store-write-off'
import { StoreCheckPages } from '../../router/routes/store-check'
import { StoreChangePages } from '../../router/routes/store-change'
import { StorePages } from '../../router/routes/store'
import { AuthPages } from '../../router/routes/auth'
import { NewsPages } from '../../router/routes/news'
import { DashboardPage } from '../../router/routes/dashboard'
import { PromotionPages } from '@/app/router/routes/promotion'
import { CustomerPages } from '@/app/router/routes/customer'
import { CustomerTypePages } from '@/app/router/routes/customer-type'
import { InventoryTypePages } from '@/app/router/routes/inventory-type'
import { OrderPages } from '@/app/router/routes/order'
import { CustomerGroupPages } from '@/app/router/routes/customer-group'
import { InventoryGroupPages } from '@/app/router/routes/inventory-group'
import { TelegramBotUserPages } from '@/app/router/routes/telegram-bot-user'
import { PriceTypePages } from '@/app/router/routes/price-type'
import { DiscountMarkupsPages } from '@/app/router/routes/discount-markups'
import { OrderReturnPages } from '@/app/router/routes/order-return'

export class AppRoutes {
  static getLogin = () => getRoute(AuthPages.login, {})
  static getTopNews = () => getRoute(NewsPages.topNews, {})
  static getDashboard = () => getRoute(DashboardPage.dashboard, {})

  static getAddUser = () => getRoute(UserPages.add, {})
  static getEditUser = (id: string) => getRoute(UserPages.edit, { id })
  static getListUser = () => getRoute(UserPages.list, {})
  static getUserProfile = () => getRoute(UserPages.profile, {})

  static getAddTelegramBotUser = () => getRoute(TelegramBotUserPages.add, {})
  static getEditTelegramBotUser = (id: string) => getRoute(TelegramBotUserPages.edit, { id })
  static getListTelegramBotUser = () => getRoute(TelegramBotUserPages.list, {})

  static getAddOrganization = () => getRoute(OrganizationPages.add, {})
  static getEditOrganization = (id: string) => getRoute(OrganizationPages.edit, { id })
  static getListOrganization = () => getRoute(OrganizationPages.list, {})

  static getAddOrder = () => getRoute(OrderPages.add, {})
  static getEditOrder = (id: string) => getRoute(OrderPages.edit, { id })
  static getListOrder = () => getRoute(OrderPages.list, {})

  static getAddOrderReturn = () => getRoute(OrderReturnPages.add, {})
  static getEditOrderReturn = (id: string) => getRoute(OrderReturnPages.edit, { id })
  static getListOrderReturn = () => getRoute(OrderReturnPages.list, {})

  static getAddCash = () => getRoute(CashPages.add, {})
  static getEditCash = (id: string) => getRoute(CashPages.edit, { id })
  static getListCash = () => getRoute(CashPages.list, {})

  static getAddDiscountMarkups = () => getRoute(DiscountMarkupsPages.add, {})
  static getEditDiscountMarkups = (id: string) => getRoute(DiscountMarkupsPages.edit, { id })
  static getListDiscountMarkups = () => getRoute(DiscountMarkupsPages.list, {})

  static getAddPromotion = () => getRoute(PromotionPages.add, {})
  static getEditPromotion = (id: string) => getRoute(PromotionPages.edit, { id })
  static getListPromotion = () => getRoute(PromotionPages.list, {})

  static getAddRegion = () => getRoute(RegionPages.add, {})
  static getEditRegion = (id: string) => getRoute(RegionPages.edit, { id })
  static getListRegion = () => getRoute(RegionPages.list, {})

  static getAddWarehouse = () => getRoute(WarehousePages.add, {})
  static getEditWarehouse = (id: string) => getRoute(WarehousePages.edit, { id })
  static getListWarehouse = () => getRoute(WarehousePages.list, {})

  static getAddRole = () => getRoute(RolePages.add, {})
  static getEditRole = (id: string) => getRoute(RolePages.edit, { id })
  static getListRole = () => getRoute(RolePages.list, {})

  static getListMetadata = () => getRoute(MetadataPages.list, {})

  static getAddCustomer = () => getRoute(CustomerPages.add, {})
  static getEditCustomer = (id: string) => getRoute(CustomerPages.edit, { id })
  static getListCustomer = () => getRoute(CustomerPages.list, {})

  static getAddCustomerType = () => getRoute(CustomerTypePages.add, {})
  static getEditCustomerType = (id: string) => getRoute(CustomerTypePages.edit, { id })
  static getListCustomerType = () => getRoute(CustomerTypePages.list, {})

  static getAddCustomerGroup = () => getRoute(CustomerGroupPages.add, {})
  static getEditCustomerGroup = (id: string) => getRoute(CustomerGroupPages.edit, { id })
  static getListCustomerGroup = () => getRoute(CustomerGroupPages.list, {})

  static getAddInventory = () => getRoute(InventoryPages.add, {})
  static getEditInventory = (id: string) => getRoute(InventoryPages.edit, { id })
  static getListInventory = () => getRoute(InventoryPages.list, {})

  static getAddInventoryType = () => getRoute(InventoryTypePages.add, {})
  static getEditInventoryType = (id: string) => getRoute(InventoryTypePages.edit, { id })
  static getListInventoryType = () => getRoute(InventoryTypePages.list, {})

  static getAddPriceType = () => getRoute(PriceTypePages.add, {})
  static getEditPriceType = (id: string) => getRoute(PriceTypePages.edit, { id })
  static getListPriceType = () => getRoute(PriceTypePages.list, {})

  static getAddInventoryGroup = () => getRoute(InventoryGroupPages.add, {})
  static getEditInventoryGroup = (id: string) => getRoute(InventoryGroupPages.edit, { id })
  static getListInventoryGroup = () => getRoute(InventoryGroupPages.list, {})

  static getAddSupplierContract = () => getRoute(SupplierContractPages.add, {})
  static getEditSupplierContract = (id: string) => getRoute(SupplierContractPages.edit, { id })
  static getListSupplierContract = () => getRoute(SupplierContractPages.list, {})

  static getAddStoreIn = () => getRoute(StoreInPages.add, {})
  static getEditStoreIn = (id: string) => getRoute(StoreInPages.edit, { id })
  static getListStoreIn = () => getRoute(StoreInPages.list, {})

  static getAddStoreWriteOff = () => getRoute(StoreWriteOffPages.add, {})
  static getEditStoreWriteOff = (id: string) => getRoute(StoreWriteOffPages.edit, { id })
  static getListStoreWriteOff = () => getRoute(StoreWriteOffPages.list, {})

  static getAddStoreCheck = () => getRoute(StoreCheckPages.add, {})
  static getEditStoreCheck = (id: string) => getRoute(StoreCheckPages.edit, { id })
  static getListStoreCheck = () => getRoute(StoreCheckPages.list, {})

  static getAddStoreChange = () => getRoute(StoreChangePages.add, {})
  static getEditStoreChange = (id: string) => getRoute(StoreChangePages.edit, { id })
  static getListStoreChange = () => getRoute(StoreChangePages.list, {})

  static getListStore = () => getRoute(StorePages.list, {})
}

function getRoute(name: string, params?: { [p: string]: string }): RouteLocationAsRelativeGeneric {
  return {
    name,
    params,
  }
}
